import { round } from 'lodash';
import { TABLE_EDITOR_DEFAULT_COLUMN_WIDTH_CSS_PX } from '../constants';

type StoredColumnWidth = number | string | null | undefined;

export default function mergeTableColumnWidths(
  stored: Array<StoredColumnWidth> | undefined,
  measured: Array<number>,
) {
  const columnCount = Math.max(stored?.length ?? 0, measured.length);
  const merged: Array<number> = [];

  for (let index = 0; index < columnCount; index++) {
    const explicit = parsePositiveColumnWidthCssPx(stored?.[index]);
    if (explicit !== null) {
      merged.push(explicit);
      continue;
    }

    const measuredWidth = measured[index];
    if (
      typeof measuredWidth === 'number' &&
      Number.isFinite(measuredWidth) &&
      measuredWidth > 0
    ) {
      merged.push(round(measuredWidth));
      continue;
    }

    merged.push(TABLE_EDITOR_DEFAULT_COLUMN_WIDTH_CSS_PX);
  }

  return merged;
}

export function tableColumnWidthsNeedSync(
  widths: Array<StoredColumnWidth> | undefined,
) {
  if (!widths?.length) {
    return true;
  }
  return widths.some((width) => parsePositiveColumnWidthCssPx(width) === null);
}

function parsePositiveColumnWidthCssPx(value: StoredColumnWidth) {
  if (typeof value === 'number' && Number.isFinite(value) && value > 0) {
    return round(value);
  }
  if (typeof value === 'string') {
    const parsed = Number(value.trim());
    if (Number.isFinite(parsed) && parsed > 0) {
      return round(parsed);
    }
  }
  return null;
}
